module.exports = __webpack_public_path__ + "img/flex5_3-front.99109b1f.jpg";